import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import MyIcon from 'src/display/components/Icon';
import moment from 'moment';
import {
    Button, 
    Radio,
    Table,
    Modal,
    Icon,
    Drawer,
    Input,
    Tooltip,
    message,
}  from 'antd';


const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state={
            agreeValue: 'agreed',
        };
    }
    componentDidMount = () => {
        if(window.location.href.indexOf('agreeingRecord') > -1) {
            this.setState({
                agreeValue: 'agreeing'
            }, () => {
                ModulesAction.agentApply();
            });
        }else {
            ModulesAction.agented();
        }
    }

    // 切换授权代理商table 
    handleAgreeChange = (e) => {
        this.setState({ agreeValue: e.target.value });
        if(e.target.value==='agreed'){
            ModulesAction.agented();
        }else if(e.target.value==='agreeing'){
            ModulesAction.agentApply();
        }
    }
    onSetAgentClose = () =>{
        this.modulesState.setAgentvisible = false;
        this.setModulesState();
    }
    // 展开设置代理商drawer
    handleShowSetAgent = () => {
        this.modulesState.setAgentvisible = true;
        this.modulesState.agentNameQueryStatus = false;
        this.modulesState.agentName = '';
        this.setModulesState();
    }
    // 确定添加代理商名字
    addAgentName = () => {
        this.modulesState.agentNameQueryStatus = true;
        this.setModulesState();
        ModulesAction.agentQueryFn(this.modulesState.agentName );
    }
    // 设置代理商提示窗口
    handleAgentModal = async() => {
        if(!this.modulesState.agentName) {
          message.destroy();
          return message.error('请输入代理商名字');
        }
        // 设置之前提前查询一次
        this.modulesState.agentNameQueryStatus = true;
        this.setModulesState();
        await ModulesAction.agentQueryFn(this.modulesState.agentName );
        if(this.modulesState.agentNameHintErr){
            return;
        }
        this.modulesState.setAgentModalVisible = true;
        this.setModulesState();
    }
    // 隐藏提示窗口
    handleAgentModalHide = () => {
        this.modulesState.setAgentModalVisible = false;
        this.setModulesState();
    }
    // 代理商名字
    handleAgentName = (e) => {
        this.modulesState.agentName = e.target.value;
        this.modulesState.agentNameQueryStatus = false;
        this.setModulesState();
    }
    // 设置代理商btn
    handleAgentModalFn = async() => {
      await ModulesAction.createAgent(this.modulesState.agentNameObj);
      await ModulesAction.agented();
      // 返回已授权tab
      this.setState({
        agreeValue: 'agreed'
      }, () => {
          ModulesAction.agented();
      });
    }
    // 刷新
    handleRefresh = () => {
        if(this.state.agreeValue === 'agreed'){
            ModulesAction.agented();
        }else{
            ModulesAction.agentApply();
        }
    }
    
    render() {
        const columns = [
            {
                title: '代理商名称',
                dataIndex: 'agentName'
            },
            {
                title: '状态',
                dataIndex: 'processStatus',
                align: 'center' as 'center',
                render: (text) => {
                    console.log(text === 2, 'aaacc');
                    return (
                        // 0 授权中
                        // 1 已拒绝
                        // 2 已授权
                        <div style={{textAlign: 'center'}}>
                            {
                                text === 2 ? '已授权' : (text === 1 ? '已拒绝' : '授权中')
                            }
                        </div>
                    );
                }
            },
            {
                title: '申请时间',
                dataIndex: 'applyTime',
                render: (text)=>{
                    return (
                        <div>{text&&moment(text).format('YYYY-MM-DD HH:mm:ss')}</div>
                    );
                }
            },
            {
                title: '操作时间',
                dataIndex: 'operateTime',
                render: (text)=>{
                    return (
                        <div>{text&&moment(text).format('YYYY-MM-DD HH:mm:ss')}</div>
                    );
                }
            },
            {
                title: '操作人',
                dataIndex: 'operateUserName',
                align: 'center' as 'center',
            },
            {
                title: '操作',
                width: 120,
                align: 'center' as 'center',
                render: (text, record) => {
                    return (
                        <div className={css['table-operate']} style={{margin: 'auto'}}>
                            <a
                                style={record.processStatus !== 0 ? {color: '#999'} : null }
                                onClick={
                                    () => {
                                        record.processStatus !== 0 ? null :
                                        Modal.confirm({
                                            title: `确定同意${record.agentName}代理商的授权申请吗？`,
                                            onOk: async()=>{
                                                await ModulesAction.handleRecordAgent(record.id, 2);
                                            }
                                        });
                                        // this.editQualificaton(1, record.qualificationId);
                                    }
                                }
                            >
                                同意
                            </a>
                            <a
                                style={record.processStatus !== 0 ? {color: '#999'} : null }
                                onClick={
                                    () => {
                                        record.processStatus !== 0 ? null :
                                        Modal.confirm({
                                            title: `确定拒绝${record.agentName}代理商的授权申请吗？`,
                                            onOk: async()=>{
                                                await ModulesAction.handleRecordAgent(record.id, 1);
                                            }
                                        });
                                    }
                                }
                            >
                                拒绝
                            </a>
                        </div>
                    );
                }
            }
        ];
        const agreedColumns = [
            {
                title: '代理商名称',
                dataIndex: 'name',
            },
            {
                title: '操作',
                width: 100,
                align: 'center' as 'center',
                render: (text, record) => {
                    return (
                        <div className={css['table-operate']}>
                            <a
                                onClick={
                                    () => {
                                        ModulesAction.cancelAgent(record.companyId);
                                    }
                                }
                            >
                                取消授权
                            </a>
                        </div>
                    );
                }
            }
        ];

        return (
            <div className={css.agentAgree}>
                <header className={css['agentAgree-header']}>
                    <Radio.Group value={this.state.agreeValue} onChange={this.handleAgreeChange}>
                        <Radio.Button value="agreed">已授权</Radio.Button>
                        <Radio.Button value="agreeing">授权申请</Radio.Button>
                    </Radio.Group>
                    <div className={css.headerWrap}>
                        <Button className={css.agentBtn} onClick={this.handleShowSetAgent}>设置代理商</Button> 
                        <div className={css.refreshBtn} onClick={()=>this.handleRefresh()}>
                            <div style={{width: '16px', height: '16px'}}>
                                <MyIcon src={require('src/display/components/Icon/refresh.svg')} width={16} height={16} className={css.refreshIcon}/>
                            </div>
                        </div>
                    </div>
                </header>
                <Table
                    className={css.table}
                    columns={this.state.agreeValue === 'agreed' ? agreedColumns : columns}
                    bordered={true}
                    dataSource={this.modulesState.tableDataList}
                    pagination={false}
                >
                </Table>
                <Drawer
                    title={<div style={{color: '#212121', fontSize: '16px',fontWeight: 700}}>设置代理商</div>}
                    placement="right"
                    // closable={false}
                    width={350}
                    onClose={this.onSetAgentClose}
                    visible={this.modulesState.setAgentvisible}
                    className={css.setAgentDrawerWrap}
                >   
                    <div>
                        <p style={{color: '#212121', fontSize: '12px',fontWeight: 700}}>代理商名字</p>
                        <div>
                        <Input
                            placeholder="请输入代理商名字"
                            value={this.modulesState.agentName}
                            onChange={this.handleAgentName}
                            suffix={<div style={{color: '#0074FF', cursor: 'pointer'}} onClick={this.addAgentName}>确定</div>}
                        />
                        </div>
                        {
                            this.modulesState.agentNameQueryStatus && (this.modulesState.agentNameHintErr ? <div style={{color:'#FF5959'}}><Icon type="info-circle" style={{color: '#FF5959', marginTop: '20px',marginRight: '3px'}} />未查找到该代理商</div>:
                            <div style={{color: '#0074FF'}}><Icon type="check-circle" style={{color: '#0074FF',marginTop: '20px',marginRight: '3px'}} />该代理商可以授权</div>)
                        }
                        
                    </div>
                    <div className={css.setAgentBtnWrap}>
                        <Button className={css.setAgentBtn} onClick={this.handleAgentModal}>设置</Button>
                        <Button className={css.cancelAgentBtn} onClick={this.onSetAgentClose}>取消</Button>
                    </div>
                </Drawer>
                <Modal
                    title="设置代理商"
                    maskClosable={false}
                    visible={this.modulesState.setAgentModalVisible}
                    onOk={this.handleAgentModalFn}
                    onCancel={this.handleAgentModalHide}
                    confirmLoading={this.modulesState.confirmStatus}
                    className='kts-app-ant-modal'
                >
                    <p>是否确认设置“{this.modulesState.agentName}”为代理商，并授权相关接口调用？</p>
                </Modal>
            </div>
        );
    }

   
}


// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/AgentAgree/UI.Components.tsx